import React, { useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp";
import { WebContext } from "../../../../../Utility";
import useStyles from "./styles";
import { StyledDrawer } from "./commons";
import { useTheme } from "@material-ui/core/styles";
import LocalStorage from "../../../../../LocalStorage";
const MobileNavDrawer = ({
  showDrawer = false,
  setShowDrawer = () => {},
  contentArr = [],
  handleLogoutClick = () => {},
  widgetList = [],
  loginItem = [],
}) => {
  let user = LocalStorage.getUser();
  const [loginOpen, setLoginOpen] = useState(false);
  let { username = "" } = user || {};
  const classes = useStyles();
  const theme = useTheme();
  const { isLoggedIn = false } = useContext(WebContext);

  const [showLogin, setShowLogin] = useState(false);
  const [expandedDropdowns, setExpandedDropdowns] = useState({});

  let [{ component: LoginComponent = null } = {}] = widgetList.filter(
    (widget) => widget.id == "loginModal"
  );

  const toggleDropdown = (itemId) => {
    setExpandedDropdowns((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  const renderNavItem = (item, index) => {
    if (!item) return null;

    if (item.dropdown && item.clickItem && Array.isArray(item.clickItem)) {
      const isExpanded = expandedDropdowns[item.id || index];

      return (
        <React.Fragment key={`dropdown-${index}`}>
          <Box className={classes.navContentContainer}>
            <div
              onClick={() => toggleDropdown(item.id || index)}
              className={classes.contentTextSideNavbar}
              style={{
                color: theme.agentTheme.card.link_foreground,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 0",
              }}
            >
              <span>{(item.label || item.name || "").toUpperCase()}</span>
              {isExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </div>
          </Box>

          {isExpanded &&
            item.clickItem.map((subItem, subIndex) => (
              <Box
                key={`sub-${index}-${subIndex}`}
                className={classes.navContentContainer}
              >
                <NavLink
                  onClick={(e) => {
                    if (item.fetchFromServer) {
                      e.preventDefault();
                      const link =
                        typeof subItem.link === "string"
                      ? subItem.link
                      : subItem.link?.pathname || "/"
                      window.location.href = link;
                    }
                  }}
                  to={
                    typeof subItem.link === "string"
                      ? subItem.link
                      : subItem.link?.pathname || "/"
                  }
                  className={classes.contentTextSideNavbar}
                  style={{
                    color: theme.agentTheme.card.link_foreground,
                    textDecoration: "none",
                    display: "block",
                    padding: "12px 0",
                    paddingLeft: "20px",
                  }}
                >
                  {(subItem.label || subItem.name || "").toUpperCase()}
                </NavLink>
              </Box>
            ))}
        </React.Fragment>
      );
    }

    if (item.link) {
      return (
        <Box key={index} className={classes.navContentContainer}>
          <NavLink
            onClick={(e) => {
              if (item.fetchFromServer) {
                e.preventDefault();
                const link =
                  typeof item.link === "string"
                    ? item.link
                    : item.link?.pathname || "/";
                window.location.href = link;
              }
            }}
            to={
              typeof item.link === "string"
                ? item.link
                : item.link?.pathname || "/"
            }
            className={classes.contentTextSideNavbar}
            style={{
              color: theme.agentTheme.card.link_foreground,
              textDecoration: "none",
              display: "block",
              padding: "12px 0",
            }}
          >
            {(item.label || item.name || "").toUpperCase()}
          </NavLink>
        </Box>
      );
    }

    return (
      <Box key={index} className={classes.navContentContainer}>
        <span
          className={classes.contentTextSideNavbar}
          style={{
            color: theme.agentTheme.card.link_foreground,
            display: "block",
            padding: "12px 0",
          }}
        >
          {(item.label || item.name || "").toUpperCase()}
        </span>
      </Box>
    );
  };

  const renderLoginItem = (username, loginItem, loginOpen, setLoginOpen) => {
    return (
      <React.Fragment>
        <Box className={classes.navContentContainer}>
          <div
            onClick={() => setLoginOpen((prev) => !prev)}
            className={classes.contentTextSideNavbar}
            style={{
              color: theme.agentTheme.card.link_foreground,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "12px 0",
            }}
          >
            <span>{`Hi, ${username}`}</span>
            {loginOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </div>
        </Box>

        {loginOpen &&
          loginItem?.map((subItem, subIndex) => (
            <Box
              key={`sub-${subIndex}`}
              className={classes.navContentContainer}
            >
              {subItem.id === "logout" ? (
                <div
                  onClick={handleLogoutClick}
                  className={classes.contentTextSideNavbar}
                  style={{
                    color: theme.agentTheme.card.link_foreground,
                    cursor: "pointer",
                    display: "block",
                    padding: "12px 0",
                    paddingLeft: "20px",
                  }}
                >
                  {(subItem.label || subItem.name || "").toUpperCase()}
                </div>
              ) : (
                <NavLink
                  to={
                    typeof subItem.link === "string"
                      ? subItem.link
                      : subItem.link?.pathname || "/"
                  }
                  className={classes.contentTextSideNavbar}
                  style={{
                    color: theme.agentTheme.card.link_foreground,
                    textDecoration: "none",
                    display: "block",
                    padding: "12px 0",
                    paddingLeft: "20px",
                  }}
                >
                  {(subItem.label || subItem.name || "").toUpperCase()}
                </NavLink>
              )}
            </Box>
          ))}
      </React.Fragment>
    );
  };

  return (
    <>
      <StyledDrawer
        anchor="left"
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
      >
        <Box
          className={classes.mobileNavDrawer}
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box
            display="flex"
            width="100%"
            justifyContent="flex-start"
            style={{ padding: "20px 20px 0 20px" }}
          >
            <IconButton
              className={classes.closeBtn}
              onClick={() => setShowDrawer(false)}
              style={{ padding: 0 }}
            >
              <CloseIcon
                style={{
                  color: theme.agentTheme.card.link_foreground,
                  fontSize: "24px",
                }}
              />
            </IconButton>
          </Box>

          <Box style={{ flex: 1, padding: "0" }}>
            {contentArr
              .filter((item) => item.isShow !== false)
              .map((item, index) => renderNavItem(item, index))}
            {!isLoggedIn && (
              <Box style={{ marginTop: "20px" }}>
                <Button
                  style={{
                    borderColor: theme.agentTheme.primary.main,
                    color: theme.agentTheme.primary.main,
                    width: "40%",
                    height: "45px",
                    marginLeft: "1.2rem",
                    backgroundColor: "transparent",
                    textTransform: "none",
                    fontSize: "1rem",
                  }}
                  variant="outlined"
                  onClick={() => setShowLogin(true)}
                >
                  Login
                </Button>
              </Box>
            )}
            {isLoggedIn &&
              renderLoginItem(username, loginItem, loginOpen, setLoginOpen)}
          </Box>
        </Box>
      </StyledDrawer>

      {showLogin && LoginComponent && (
        <LoginComponent onClose={() => setShowLogin(false)} />
      )}
    </>
  );
};

export default MobileNavDrawer;
